import React from "react";
import { useMyTimeAppbarBadge } from "./use-appbar-badge";
import { OcAppBarBadge } from "oc/components";

export const MyTimeAppbarBadge: React.FC = () => {
  const { handleClick, count } = useMyTimeAppbarBadge();
  if (count === 0) return null;

  return (
    <OcAppBarBadge
      icon="mdi:clock"
      value={count}
      onClick={handleClick}
      id="my-time-header-badge"
      badgeId="my-time-header-badge-count"
    />
  );
};
